import React from "react";
import { FormControl, MenuItem, Select, InputLabel } from "@material-ui/core";
import { observer } from "mobx-react";

import ColumnConfigFactory from "../../ColumnConfigFactory";
const FORMULA_DATA_TYPES = [
  { name: "Text", val: "text", column_type_id: "1", icn: "text.png" },
  { name: "Date", val: "date", column_type_id: "4", icn: "date_icon.png" },
  {
    name: "DateTime",
    val: "datetime",
    column_type_id: "16",
    icn: "date_icon.png",
  },
  { name: "Number", val: "number", column_type_id: "5", icn: "num.png" },
  // {"name": "Boolean", "val": "boolean", "icn": "num.png"},
  {
    name: "Currency",
    val: "currency",
    column_type_id: "17",
    icn: "currency.png",
  },
];

function FormulaDataType({
  store,
  values,
  handleChange,
  setFieldValue,
}) {
  return (
    <>
      <FormControl style={{ paddingTop: 5 }}>
        <InputLabel id="default_value_label">Formula Data Type</InputLabel>
        <Select
          labelId="default_value_label"
          id="default_value"
          name="options.formula_column.column_type_id"
          value={values.options.formula_column?.column_type_id}
          onChange={(e) => {
            setFieldValue("options.formula_column.options", {});
            handleChange(e);
          }}
          open={store.isFormulaDataTypeOpen}
          onOpen={() => {
            store.setIsFormulaDataTypeOpen(true);
          }}
          onClose={() => {
              store.setIsFormulaDataTypeOpen(false);
          }}
        >
          {FORMULA_DATA_TYPES.map((dataType) => (
            <MenuItem
              key={dataType.column_type_id}
              value={dataType.column_type_id}
            >
              {dataType.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <ColumnConfigFactory
        values={values.options.formula_column}
        valuesPath={"options.formula_column."}
        handleChange={handleChange}
        setFieldValue={setFieldValue}
        isOnlyFormattingConfig={true}
      />
    </>
  );
}

export default observer(FormulaDataType);